import { websockets } from '../../engine/websockets-sidecar'
import { l } from '../../lib/imports'
import { clickEater } from '../../uiParts/clickEater-sidecar'
import { stevieTexts2 } from '../../uiParts/stevieTexts2-sidecar'
import { echoFonts } from '../echo/echoFonts-sidecar'
import { voyageCamera } from './voyageCamera-sidecar'
import { voyageLayers } from './voyageLayers-sidecar'
import type { IVoyageUiCanvas } from './voyageUiCanvas'
import { voyageUiCanvas } from './voyageUiCanvas-sidecar'
import type { IVoyageGButton } from './voyageUiGButtons'
import { voyageUiGButtons } from './voyageUiGButtons-sidecar'
import { voyageUiGraphicsUtils } from './voyageUiGraphicsUtils-sidecar'
import { voyageWebsockets } from './voyageWebsockets-sidecar'

interface IVoyageUiMultiListGames extends IVoyageUiCanvas {
  isRefreshing: boolean
  buttonsGames: IVoyageGButton[]
  lastListLength: number
}
let _obj: IVoyageUiMultiListGames | null = null
export function get() {
  if (!_obj) {
    _obj = create()
    createButtons()
    setOpen(false)
    render()
  }
  return _obj
}

const create = () => {
  let tw = 600
  let th = 700

  let canvas = voyageUiCanvas.create(tw, th, voyageLayers.getLayers().uiMessage)
  canvas.autoOffset = false

  let obj: IVoyageUiMultiListGames =
    voyageUiCanvas.assign<IVoyageUiMultiListGames>(canvas, {
      isRefreshing: false,
      buttonsGames: [],
      lastListLength: 0,
    })

  // voyageUiCanvas

  // obj.buttons = [
  //   voyageUiGButtons.create('Ok', 50, 50, () => {
  //     get().onOk()
  //     setOpen(false)
  //   }),
  // ]

  return obj
}

const createButtons = () => {
  let obj = get()
  obj.buttons = [
    voyageUiGButtons.create('Cancel', 50, 50, () => {
      setOpen(false)
    }),
    voyageUiGButtons.create('Refresh', 250, 50, () => {
      obj.isRefreshing = true
    }),
  ]

  let list = websockets.getGameList()
  let x = 0
  let y = 0
  l.forEach(list, (c) => {
    obj.buttons.push(
      voyageUiGButtons.create(c.key + ' (' + c.numPlayers + ')', x, y, () => {
        setOpen(false)
        websockets.joinChannel(c.key, false, '')
      }),
    )
  })
}

const render = () => {
  let obj = get()
  let g = obj.graphics

  voyageUiCanvas.clear(obj)

  let addText = (text: string, x: number, y: number) => {
    let _text = stevieTexts2.create(echoFonts.getData().font6, x, y, obj.layer)
    stevieTexts2.setText(_text, text)
    stevieTexts2.setScale(_text, 3)
    obj.texts.push(_text)
    return _text
  }

  g.clear()

  let gb = voyageCamera.getGameBounds()

  g.fillStyle(0x222222, 0.67)
  g.fillRect(0, 0, gb.width, gb.height)

  let w = obj.targetWidth
  let h = obj.targetHeight

  let x = (gb.width - w) / 2
  let y = (gb.height - h) / 2

  voyageUiGraphicsUtils.bevelPanel(g, x, y, w, h)

  addText('Open games', x + 6, y)

  // let textDesc = addText(obj.textDesc, x + 6 + 20, y + 40)
  // stevieTexts2.setWrapWidth(textDesc, obj.targetWidth - 50)

  x += 20
  y += h - 60
  obj.buttons[0].x = x
  obj.buttons[0].y = y
  obj.buttons[1].x = x + 200
  obj.buttons[1].y = y
  obj.buttons[1].text = obj.isRefreshing ? 'Refreshing...' : 'Refresh'

  x = (gb.width - w) / 2 + 20
  y = (gb.height - h) / 2 - 20
  l.forEach(obj.buttons, (c, cIdx) => {
    if (cIdx <= 1) {
      return
    }
    y += 50
    c.x = x
    c.y = y
  })

  voyageUiCanvas.render(obj)
}

export const setOpen = (isOpen: boolean, onOk = () => {}) => {
  let obj = get()
  voyageUiCanvas.setOpen(obj, isOpen)
  obj.isRefreshing = isOpen
  // obj.onOk = onOk
  if (isOpen) {
    update()
  }
}

export const update = () => {
  let obj = get()

  if (obj.isOpen) {
    if (obj.isRefreshing) {
      if (websockets.isStillConnecting()) {
        obj.isRefreshing = true
      } else {
        websockets.refreshGameList()
        obj.isRefreshing = false
      }
    }

    let list = websockets.getGameList()
    if (obj.lastListLength !== list.length) {
      obj.lastListLength = list.length
      createButtons()
    }

    voyageUiCanvas.update(obj)
    render()
    clickEater.tempEatCursor()
  } else {
    voyageUiCanvas.clear(obj)
  }
}
